import baseRoutes from './base.routes';
import errorBroadcast from './services/error.broadcast.service';

import apiFormController from './controllers/api.form.controller';
import appController from './controllers/app.controller';
import fileUploadController from './controllers/fileUpload.input.controller';
import adminMenuController from './controllers/admin.menu.controller';
import messageController from './controllers/message.controller';
import auditController from './controllers/audit.controller';

import apiFormComponent from './components/api.form.component';
import fileUploadComponent from './components/fileUpload.input.component';
import appComponent from './components/app.component';
import spinnerComponent from './components/spinner.component';
import adminMenuComponent from './components/admin.menu.component';
import messageComponent from './components/message.component';
import auditComponent from './components/audits.component';
import helpAreaComponent from './components/help.area.component';
import textCheatsheetComponent from './components/text.cheatsheet.component';
import periodCheatsheetComponent from './components/period.cheatsheet.component';

import logoWordsComponent from './components/logoWords.component';
import logoIconComponent from './components/logoIcon.component';
import iconComponent from './components/icon.component';
import brandingComponent from './components/brandingBanner.component';

import formFieldErrorsDirective from './directives/formFieldErrors.directive';
import requiredDirective from './directives/required.directive';
import confirmDirective from './directives/confirm.directive';
import markdownDirective from './directives/markdown.directive';

import markdownService from './services/markdown.service';
import apiService from './services/api.service';
import messageService from './services/message.service';
import accessService from './services/access.service';
import readabilityService from './services/readability.service';
import auditService from './services/audit.service';
import currentPropertyService from './services/currentProperty.service';

let baseModule = angular.module('spabooker.base', [])
    .config(baseRoutes)
    .config(errorBroadcast)

    .controller('appController', appController)
    .controller('apiFormController', apiFormController)
    .controller('fileUploadController', fileUploadController)
    .controller('adminMenuController', adminMenuController)
    .controller('messageController', messageController)
    .controller('auditController', auditController)

    .component('apiForm', apiFormComponent)
    .component('fileUpload', fileUploadComponent)
    .component('app', appComponent)
    .component('spinner', spinnerComponent)
    .component('adminMenu', adminMenuComponent)
    .component('message', messageComponent)
    .component('audits', auditComponent)
    .component('helpArea', helpAreaComponent)
    .component('textCheatsheet', textCheatsheetComponent)
    .component('periodCheatsheet', periodCheatsheetComponent)

    .component('logoWords', logoWordsComponent)
    .component('logoIcon', logoIconComponent)
    .component('icon', iconComponent)
    .component('branding', brandingComponent)

    .directive('formFieldErrors', formFieldErrorsDirective)
    .directive('required', requiredDirective)
    .directive('ngRequired', requiredDirective)
    .directive('confirm', confirmDirective)
    .directive('markdown', markdownDirective)

    .factory('markdownService', markdownService)
    .factory('readabilityService', readabilityService)
    .factory('messageService', messageService)
    .factory('access', accessService)
    .factory('api', apiService)
    .factory('auditService', auditService)
    .factory('currentPropertyService', currentPropertyService)
    ;

export default baseModule.name;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/index.js